var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('UdefHero',{attrs:{"img":"/img/hero-about.webp"}},[_c('div',{staticClass:"hero-title"},[_c('span',[_vm._v("Unify to liberate")])])]),_c('AboutStory'),_c('AboutPeoplesBehind')],1)}
var staticRenderFns = []

export { render, staticRenderFns }